import { existValueAndEmptyString } from "./util";

export function formatNumber(num, minimumFractionDigits = 0) {
  return num.toLocaleString(undefined, { minimumFractionDigits });
}

export function normalizeCurrencyInputString(value) {
  if (value === null || value === undefined) {
    return value;
  }

  return String(value)
    .split("")
    .reduce((currencyInput, character) => {
      if (/\d/.test(character)) {
        return `${currencyInput}${character}`;
      }

      if (character === "." && currencyInput.indexOf(".") === -1) {
        return `${currencyInput}${character}`;
      }

      return currencyInput;
    }, "");
}

export function parseCurrencyInputNumber(value) {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  if (typeof value === "string" && value.trim().indexOf("-") === 0) {
    return null;
  }

  const normalizedValue = normalizeCurrencyInputString(value);

  if (normalizedValue === "" || normalizedValue === ".") {
    return null;
  }

  const currencyValue = Number(normalizedValue);

  return Number.isFinite(currencyValue) ? currencyValue : null;
}

export function formatCurrencyAndTwoDecimalsString(
  number,
  minimumFractionDigits = 2,
  symbol = undefined
) {
  return number
    ? `${symbol || ""}${formatNumber(number, minimumFractionDigits)}`
    : number;
}

export function convertSatangToBahtAndRoundTwoDecimal(num) {
  const floatItem = num !== null && num >= 0
    ? +`${Math.round(`${+num / 100}e+2`)}e-2`
    : undefined

  return floatItem
}

export function convertBathToStangAndRoundTwoDecimal(num) {
  return convertSatangToBahtAndRoundTwoDecimal(num);
}

export function roundToTwoAndMultiplyOneHundred(num) {
  return +`${Math.round(`${num * 100}e+2`)}e-2`;
}

export function convertBahtToSatangAndRoundTwoDecimal(num) {
  const numericValue = parseCurrencyInputNumber(num);

  if (numericValue === null || numericValue < 0) {
    return null;
  }

  const multiplyMoney = roundToTwoAndMultiplyOneHundred(numericValue);

  return parseInt(multiplyMoney, 10);
}

export function formatToMoney(num, minimumFractionDigits = 2, symbol = undefined) {
  return formatCurrencyAndTwoDecimalsString(
    convertBathToStangAndRoundTwoDecimal(num), minimumFractionDigits, symbol
  );
}

export function convertPriceStringToInt(item) {
  const price = item && item >= 0
    ? parseInt((parseFloat(item) * 100).toFixed(2), 10)
    : null

  return price
}

export function convertStangToBathAndRoundTwoDecimal(num) {
  return convertBahtToSatangAndRoundTwoDecimal(num);
}

export function formatDecimal(num, decimalDigits = 2) {
  const floatItem = num >= 0
    ? parseFloat(num.toFixed(decimalDigits))
    : undefined

  return floatItem
}

// Spreads a total across appointment rows, giving the last row the remainder so the
// rows always add up to the total despite per-row rounding.
export function distributePrice(appointments, totalPrice) {
  // A package option without appointments carries no appointment list at all.
  if (!appointments || appointments.length === 0) {
    return;
  }

  const count = appointments.length;
  let accumulated = 0;

  for (let index = 0; index < count; index += 1) {
    const appointment = appointments[index];
    const isLastItem = index === count - 1;

    if (count === 1 || !isLastItem) {
      appointment.appoint_price = formatDecimal(totalPrice / count);
      accumulated = formatDecimal(accumulated + appointment.appoint_price);
    } else {
      appointment.appoint_price = formatDecimal(totalPrice - accumulated);
    }
  }
}

export function convertPriceStringToNumber(priceString) {
  return priceString
    ? parseFloat(priceString.replace(/,/g, ''))
    : null;
}

export function formatCurrencyBath(priceString) {
  return existValueAndEmptyString(priceString)
    ? formatCurrencyAndTwoDecimalsString(priceString, 2, "฿")
    : null;
}
